import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'

import { useSellElectricities } from '../../hooks/use-sell-electricity'
import WizardSellElectricityForm from './sell-electricity-form'

function WizardSellElectricityWrapper({
    estateId,
    goBack,
    nextStep,
} : {
    estateId: string | number | undefined,
    goBack: () => void,
    nextStep: () => void,
}) {

    const { status, data, error } = useSellElectricities(estateId)

    if (status === 'pending') {
        return (
            <CircularProgress />
        )
    }

    if (error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{error.message}</Box>
            </Box>
        )
    }

    if (data.length > 0) {
        return (
            <WizardSellElectricityForm
                estateId={estateId}
                sellElectricity={data[0]}
                goBack={goBack}
                nextStep={nextStep} 
            />
        )
    } else {
        return (
            <WizardSellElectricityForm
                estateId={estateId}
                goBack={goBack}
                nextStep={nextStep} 
            />
        )
    }
    
}

export default WizardSellElectricityWrapper
